import { render } from "./Phases.vue?vue&type=template&id=7ce77943&scoped=true"
import script from "./Phases.vue?vue&type=script&lang=js"
export * from "./Phases.vue?vue&type=script&lang=js"

import "@/assets/scss/_phases.scss?vue&type=style&index=0&id=7ce77943&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ce77943"]])

export default __exports__